import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;


const AttendancesService = {
    list: async (status) => axios.post(API_URL + "/attendances/list", {filters: {status}}).then(({data}) => data).catch(err => { throw err }),

    get: async (id, type) => axios.get(API_URL + "/attendances/" + id + "/" + type).then(({data}) => data).catch(err => { throw err }),

    create: async (model) => axios.post(API_URL + "/attendances", model).then(({data}) => data).catch(err => { throw err }),

    getProducts: async () => axios.get(API_URL + "/attendances/getProducts").then(({data}) => data).catch(err => { throw err }),
};

export default AttendancesService;